var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaturity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/calculator"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09467 2.09467C3.42914 0.760201 5.42603 0.25 8 0.25H12C14.574 0.25 16.5709 0.760201 17.9053 2.09467C19.2398 3.42914 19.75 5.42603 19.75 8V14C19.75 16.574 19.2398 18.5709 17.9053 19.9053C16.5709 21.2398 14.574 21.75 12 21.75H8C5.42603 21.75 3.42914 21.2398 2.09467 19.9053C0.760201 18.5709 0.25 16.574 0.25 14V8C0.25 5.42603 0.760201 3.42914 2.09467 2.09467ZM3.15533 3.15533C2.2398 4.07086 1.75 5.57397 1.75 8V14C1.75 16.426 2.2398 17.9291 3.15533 18.8447C4.07086 19.7602 5.57397 20.25 8 20.25H12C14.426 20.25 15.9291 19.7602 16.8447 18.8447C17.7602 17.9291 18.25 16.426 18.25 14V8C18.25 5.57397 17.7602 4.07086 16.8447 3.15533C15.9291 2.2398 14.426 1.75 12 1.75H8C5.57397 1.75 4.07086 2.2398 3.15533 3.15533Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.83C6.58746 5.83 6.25 6.17096 6.25 6.58V7.58C6.25 7.99254 6.59096 8.33 7 8.33H13C13.4125 8.33 13.75 7.98904 13.75 7.58V6.58C13.75 6.16422 13.4158 5.83 13 5.83H7ZM4.75 6.58C4.75 5.34904 5.75254 4.33 7 4.33H13C14.2442 4.33 15.25 5.33579 15.25 6.58V7.58C15.25 8.81096 14.2475 9.83 13 9.83H7C5.76904 9.83 4.75 8.82746 4.75 7.58V6.58Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13623 13C5.13623 12.4477 5.58395 12 6.13623 12H6.14778C6.70007 12 7.14778 12.4477 7.14778 13C7.14778 13.5523 6.70007 14 6.14778 14H6.13623C5.58395 14 5.13623 13.5523 5.13623 13Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99512 13C8.99512 12.4477 9.44283 12 9.99512 12H10.0067C10.559 12 11.0067 12.4477 11.0067 13C11.0067 13.5523 10.559 14 10.0067 14H9.99512C9.44283 14 8.99512 13.5523 8.99512 13Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8542 13C12.8542 12.4477 13.302 12 13.8542 12H13.8658C14.4181 12 14.8658 12.4477 14.8658 13C14.8658 13.5523 14.4181 14 13.8658 14H13.8542C13.302 14 12.8542 13.5523 12.8542 13Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13623 16.5C5.13623 15.9477 5.58395 15.5 6.13623 15.5H6.14778C6.70007 15.5 7.14778 15.9477 7.14778 16.5C7.14778 17.0523 6.70007 17.5 6.14778 17.5H6.13623C5.58395 17.5 5.13623 17.0523 5.13623 16.5Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99512 16.5C8.99512 15.9477 9.44283 15.5 9.99512 15.5H10.0067C10.559 15.5 11.0067 15.9477 11.0067 16.5C11.0067 17.0523 10.559 17.5 10.0067 17.5H9.99512C9.44283 17.5 8.99512 17.0523 8.99512 16.5Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8542 16.5C12.8542 15.9477 13.302 15.5 13.8542 15.5H13.8658C14.4181 15.5 14.8658 15.9477 14.8658 16.5C14.8658 17.0523 14.4181 17.5 13.8658 17.5H13.8542C13.302 17.5 12.8542 17.0523 12.8542 16.5Z",
    fill: "#3C3C3B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaturity);
export default __webpack_public_path__ + "static/media/maturity.3744bfa7db2af0e53c06f24be50530d9.svg";
export { ForwardRef as ReactComponent };